import EditorInstance from './Editor';

export const Editor = EditorInstance;
export default Editor;
